export const SINGLE_AND_MULTISELECT_DROPDOWN_HEIGHT = 160;
